import React from "react";
import AttractionsPage from "./AttractionPage";

const Attractions = () => {
  return (
    <div>
      <AttractionsPage />
    </div>
  );
};

export default Attractions;
